import { Reference } from '@approvalmax/types';
import {
    AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource,
    AmaxPayXeroDomainEntitiesApprovalEntitiesVirtualAccountsPaymentChargeType,
    ApiTypes,
} from 'shared/data/webApp/v2';

import { domain } from '../index';
import { SelectableBillItemForBatchPaymentAdditionalData } from './BatchPayment';
import { PaymentDetails } from './Payments';

export enum AmaxPayPaymentStatus {
    None = 'none',
    ReadyToPay = 'ready-to-pay',
    CancelledByUser = 'cancelled-by-user',
    Processing = 'processing',
    Scheduled = 'scheduled',
    Paid = 'paid',
    Failed = 'failed',
}

export enum AmaxPayXeroBatchPaymentStatus {
    None = 'none',
    AwaitingPayment = 'awaiting-payment',
    Processing = 'processing',
    PartiallyPaid = 'partially-paid',
    Paid = 'paid',
    Failed = 'failed',
    Cancelled = 'cancelled',
}

export enum PaymentDetailsPaymentStatus {
    NotChecked = 'not-checked',
    PaidPreviously = 'paid-previously',
    NeverPaid = 'never-paid',
    PaymentDetailsChanged = 'payment-details-changed',
}

export interface AmaxPayPaymentItem {
    xeroBillInvoiceRequestId: string;
    amaxPayBankAccount: Reference | null;
    amaxPayWallet?: ApiTypes['ApiAmaxPayVirtualAccountsWallet'];
    /**
     * The wallet id which appears on edit ony when user selects new wallet in line
     */
    amaxPayWalletId?: string;
    amount: number;
    amountDue: number;
    amountOnApproval?: number;
    amountInProcessing?: number;
    amountAwaitingPayment?: number;
    amountOnReview?: number;
    date: string;
    dueDate: string;
    scheduledDate?: string;
    friendlyName: string;
    paymentChargeType: AmaxPayXeroDomainEntitiesApprovalEntitiesVirtualAccountsPaymentChargeType;
    /**
     * @see https://support.currencycloud.com/hc/en-gb/articles/360017430000-Payment-Purpose-Codes
     */
    paymentPurposeCode?: string;
    paymentPurposeDescription?: string;
    paymentDetails: Omit<PaymentDetails, 'isDefault'> | null;
    paymentReference: string | null;
    contact: (Reference & { defaultReference?: string }) | null;
    currency: string;
    attachments?: domain.RequestAttachment[];
    paymentStatus?: AmaxPayPaymentStatus;
    paymentDetailsPaymentStatus?: PaymentDetailsPaymentStatus;
    xeroUrl?: string;
    statusUpdatedAt?: string;
}

export interface XeroAmaxPayBatchPayment {
    status: AmaxPayXeroBatchPaymentStatus | null;
    items: AmaxPayPaymentItem[];
    isMergedBySupplier: boolean;
    paymentSource: AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource;
    referencesForMergedItems?: Record<string, string>;
}

export interface AmaxPayBatchSelectableBillItem
    extends domain.AmaxPayPaymentItem,
        SelectableBillItemForBatchPaymentAdditionalData {}
